// Learn Tab Content - Educational articles about habit building
export const learnArticles = [
  {
    id: 1,
    title: "The 2-Minute Rule That Actually Sticks",
    readTime: "2 min read",
    category: "Method",
    content: `<p>Big goals fail because they're intimidating; small ones stick because they're easy to start.</p>
              <p>The <strong>2-Minute Rule</strong> says any new habit should take less than two minutes to start.</p>
              <h3>Why It Works</h3>
              <p>Psychological studies show that the hardest part of any task is <em>starting</em>. The Two-Minute Rule bypasses procrastination by lowering the threshold for action.</p>
              <h3>The Neuroscience</h3>
              <p>Each small action creates a neural link that strengthens with repetition. Dopamine spikes from completing even quick tasks inspire motivation. Over time, the brain rewires to associate starting with reward.</p>
              <h3>How to Use It</h3>
              <ul>
                <li>Open a blank document—write one sentence.</li>
                <li>Lay out your workout clothes.</li>
                <li>Wash one dish.</li>
              </ul>
              <p>The Two-Minute Rule transforms "I should" into "I did."</p>`,
    ctaText: "Pick today's Tiny Win",
    ctaLink: "/dashboard"
  },
  {
    id: 2,
    title: "Stop All-or-Nothing Thinking",
    readTime: "3 min read",
    category: "Mindset",
    content: `<p>All-or-nothing thinking creates cycles of boom and bust—days of overexertion followed by burnout and guilt.</p>
              <p>People who thrive in discipline don't rely on swings of motivation. Instead, they build <strong>balanced thinking</strong>: steady, sustainable patterns that prevent relapse.</p>
              <h3>Why This Mental Shift Matters</h3>
              <p>Behavioral psychologists link black-and-white thinking to reduced resilience. Replacing absolute thoughts ("I failed") with realistic self-appraisal ("I slipped today") decreases stress.</p>
              <h3>Try This</h3>
              <p><strong>Morning:</strong> Ask, "What's the one nudge I'll show up for today?"</p>
              <p><strong>Evening:</strong> Ask, "Did I show up? If not, what small reset can I do tomorrow?"</p>
              <p>Balance isn't about perfection—it's about staying in motion without crashing.</p>`,
    ctaText: "Set your Preferences",
    ctaLink: "/settings"
  },
  {
    id: 3,
    title: "From Streaks to Momentum",
    readTime: "2 min read",
    category: "Maintenance",
    content: `<p>Habit tracking becomes sustainable when you replace streak obsession with <strong>momentum awareness</strong>.</p>
              <h3>The Psychology of Momentum</h3>
              <p>Momentum gives emotional rewards like satisfaction and confidence. Small wins act as mini dopamine boosts that remind you progress is happening, even when results aren't visible.</p>
              <h3>How to Use Your Weekly Insight</h3>
              <p>During your weekly review, ask:</p>
              <ul>
                <li>Which habit felt effortless?</li>
                <li>Which felt forced or draining?</li>
              </ul>
              <p>Momentum thrives not from never missing, but from never stopping. Keep your habits alive by noticing the flow, not the streak.</p>`,
    ctaText: "Check your Progress",
    ctaLink: "/dashboard"
  },
  {
    id: 4,
    title: "Identity-Based Habits",
    readTime: "3 min read",
    category: "Mindset",
    content: `<p>The most powerful way to change your behavior is to change your <strong>identity</strong>.</p>
              <p>Instead of focusing on what you want to achieve, focus on who you want to become.</p>
              <h3>The Three Layers of Behavior Change</h3>
              <ul>
                <li><strong>Outcomes:</strong> What you get (lose weight, publish a book)</li>
                <li><strong>Processes:</strong> What you do (go to the gym, write daily)</li>
                <li><strong>Identity:</strong> What you believe (I am a healthy person, I am a writer)</li>
              </ul>
              <h3>Why Identity Matters</h3>
              <p>When your behavior and identity are aligned, you're no longer pursuing behavior change—you're acting like the type of person you already believe yourself to be.</p>
              <p>Every action you take is a vote for the type of person you wish to become.</p>`,
    ctaText: "Define Your Identity",
    ctaLink: "/architect"
  },
  {
    id: 5,
    title: "The Power of Environment Design",
    readTime: "2 min read",
    category: "Method",
    content: `<p>Your environment shapes your behavior more than willpower ever will.</p>
              <p><strong>Environment design</strong> is the practice of adjusting your surroundings to make good habits easier and bad habits harder.</p>
              <h3>Make It Obvious</h3>
              <ul>
                <li>Put your vitamins next to your coffee maker</li>
                <li>Leave your book on your pillow</li>
                <li>Set your workout clothes out the night before</li>
              </ul>
              <h3>Make It Invisible</h3>
              <ul>
                <li>Put your phone in another room while working</li>
                <li>Remove unhealthy snacks from your kitchen</li>
                <li>Unsubscribe from tempting newsletters</li>
              </ul>
              <p>Design your environment for the person you want to become.</p>`,
    ctaText: "Set Your Anchor",
    ctaLink: "/architect"
  }
];
